import styled from 'styled-components'

import { background2 } from '../../../styles/colors'
import { center, hFlex, square, vFlex } from '../../../styles/style-helpers'

export const EndorsementsEl = styled.div`
  width: 100%;
  ${hFlex};
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;

  .logo {
    ${square('4em')};
    border-radius: 50%;
    overflow: hidden;
    background: #232323;
    margin: 1em 1em 1em 0;
    cursor: pointer;

    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }
`

export const DetailViewEl = styled.div`
  width: 90vw;
  max-height: 85vh;
  overflow: auto;
  background: ${background2};
  border-radius: 0.5em;
  ${center};
  ${vFlex};
  color: white;
  padding: 2em 1em 1em;

  .logo {
    ${square('66vw')};
    margin-bottom: 1em;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 0.5em;
    }
  }

  button {
    margin: 0.25em;

    svg {
      fill: white;
    }
  }

  .details {
    width: 100%;
    padding: 1em 0;
    ${vFlex};
    justify-content: space-between;

    p {
      opacity: 0.7;
      width: 100%;
      text-align: center;
    }

    h3 {
      margin: 1em 0;
      width: 100%;
      text-align: center;
    }

    .actions {
      width: 100%;
      ${hFlex};
      justify-content: space-around;

      button {
        width: 35vw;
      }
    }
  }
`
